import React from 'react';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import factoringDataInfo from '../../constants/products/factoring';
import ProductHero from './components/ProductHero';
import ProductSection from './components/ProductSection';
import FactoringVideoSection from './components/FactoringVideoSection';
import RecommendationSection from './components/RecommendationSection';
import { STACK_PRODUCT_SECTION_COMPONENT } from '../../constants/mui-components';
import useGetCountry from '../../helpers/useGetCountry';
import CountryEnum from '../../constants/country-enum';

function Factoring() {
  const { t } = useTranslation();
  const country = useGetCountry();
  const factoringData = factoringDataInfo(t);
  const location = useLocation();
  const benefitsInformationMapper = {
    Chile: factoringData.benefits_information,
    Mexico: {
      ...factoringData.benefits_information,
      text: factoringData.benefits_information.text.filter(
        (item) => !item.includes('Nuestro equipo analiza rápidamente'),
      ),
    },
  };
  if (country === CountryEnum.MEXICO && location.pathname === '/factoring') {
    return <Navigate to="/factoraje" replace />;
  }
  if (country === CountryEnum.CHILE && location.pathname === '/factoraje') {
    return <Navigate to="/factoring" replace />;
  }
  return (
    <>
      <ProductHero productData={factoringData} />
      <Stack className={STACK_PRODUCT_SECTION_COMPONENT}>
        <ProductSection productData={factoringData.description_information} />
        <ProductSection
          productData={benefitsInformationMapper[country]}
          flexDirection="row-reverse"
        />
        { country === CountryEnum.CHILE && (
          <>
            <ProductSection
              productData={factoringData.requirements_information}
              stackProps={{
                style: {
                  gap: '2rem',
                },
              }}
            />
            <FactoringVideoSection />
          </>
        )}
        <RecommendationSection actualProductName={factoringData.name} />
      </Stack>
    </>
  );
}

export default Factoring;
